import { forwardRef } from 'react';
import { MagnifyingGlass, X } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';

/**
 * Searchbar (ds/input/search).
 */
export const SearchInput = forwardRef(function SearchInput(
  {
    className,
    inputClassName,
    value,
    onChange,
    onClear,
    placeholder = 'Pesquisar…',
    suggestions,
    onSuggestionSelect,
    ...props
  },
  ref,
) {
  const showClear = Boolean(value) && typeof onClear === 'function';
  const open = Array.isArray(suggestions) && suggestions.length > 0;

  return (
    <div
      className={cn('relative w-full', className)}
      data-ds-id={showClear ? 'ds/input/search--with-clear' : 'ds/input/search--default'}
    >
      <MagnifyingGlass
        className="pointer-events-none absolute left-space-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <input
        ref={ref}
        type="search"
        role="combobox"
        aria-expanded={open}
        aria-controls={open ? 'ds-search-suggestions' : undefined}
        aria-autocomplete="list"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={cn(
          'w-full rounded-ds-full border border-input-border bg-card py-space-2-5 pl-space-10 pr-space-10 text-type-body text-foreground placeholder:text-muted-foreground focus:border-sage-500 focus:outline-none focus:ring-4 focus:ring-sage-glow-soft',
          inputClassName,
        )}
        {...props}
      />
      {showClear ? (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-space-3 top-1/2 grid size-5 -translate-y-1/2 place-items-center rounded-ds-full bg-muted text-muted-foreground hover:text-foreground"
          aria-label="Limpar pesquisa"
        >
          <X className="size-3" />
        </button>
      ) : null}
      {open ? (
        <ul
          id="ds-search-suggestions"
          role="listbox"
          className="absolute inset-x-0 top-full z-20 mt-space-2 space-y-space-1 rounded-ds-md border border-border bg-card p-space-1 shadow-2xl"
        >
          {suggestions.map((item) => {
            const key = typeof item === 'string' ? item : item.id ?? item.label;
            const label = typeof item === 'string' ? item : item.label;
            return (
              <li key={key}>
                <button
                  type="button"
                  role="option"
                  aria-selected={false}
                  className="flex w-full items-center gap-space-2 rounded-ds-sm px-space-3 py-space-2 text-left text-type-body-sm hover:bg-sage-tint"
                  onClick={() => onSuggestionSelect?.(item)}
                >
                  {label}
                </button>
              </li>
            );
          })}
        </ul>
      ) : null}
    </div>
  );
});

export default SearchInput;
